module.exports = __webpack_public_path__ + "img/main-03-09-HIW.e3a8ee5b.png";